import { RemoveConfirmationAlert } from '@components/dialogs/removeConfirmationAlert';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { useJobContext } from '@contexts/job';
import { useRemoveStage } from '@services/jobs/stages/remove';
import { useTranslation } from 'react-i18next';

export interface JobStageRemoveProps {
  stageId: string;
  name: string;
}

export const JobStageRemove = ({ stageId, name }: JobStageRemoveProps) => {
  const { job } = useJobContext();
  const { mutate, isLoading } = useRemoveStage();
  const { t } = useTranslation('app');

  const handleRemove = () => {
    const jobId = job?.data?.data?.id;

    if (!jobId) return;
    mutate({ jobId, id: stageId });
  };

  return (
    <RemoveConfirmationAlert
      title={t('pages.job.removeStage.title')}
      description={t('pages.job.removeStage.description', { name })}
      onConfirm={handleRemove}
      locked={isLoading}>
      <Button
        variant="ghost"
        size="sm"
        className="px-2 max-[899px]:h-11 max-[899px]:w-11 max-[899px]:p-0 max-[899px]:text-lg">
        <SvgConsumer id="trash" className="text-m" />
      </Button>
    </RemoveConfirmationAlert>
  );
};
